import React from 'react';
import { Link } from 'react-router-dom';
import { SoapIcon } from './shared/icons';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Learn: [
      { path: '/learn', label: 'Beginner Guide' },
      { path: '/safety', label: 'Safety First' },
      { path: '/glossary', label: 'Glossary' },
    ],
    Recipes: [{ path: '/recipes', label: 'Starter Recipes' }],
    Resources: [
      { path: '/faq', label: 'FAQ' },
      { path: '/disclaimer', label: 'Disclaimer' },
    ],
  };

  return (
    <footer className='bg-charcoal text-white'>
      <div className='max-w-7xl mx-auto px-4 py-12'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8'>
          {/* Brand */}
          <div className='col-span-1 md:col-span-2'>
            <div className='flex items-center space-x-2 mb-4'>
              <div className='w-8 h-8 bg-muted-green rounded-lg flex items-center justify-center'>
                <SoapIcon className='w-5 h-5 text-white' />
              </div>
              <span className='text-xl font-serif font-bold text-muted-green'>
                Cold Process Soaps
              </span>
            </div>
            <p className='text-cream text-sm leading-relaxed max-w-md'>
              Master the art of cold process soap making with our comprehensive
              guides, recipes, and tools. Learn safely and create beautiful,
              natural handmade soap.
            </p>
          </div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className='text-muted-green font-semibold mb-4'>
                {category}
              </h3>
              <ul className='space-y-2'>
                {links.map(link => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className='text-cream hover:text-muted-green transition-colors duration-200 text-sm'
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className='border-t border-gray-700 mt-8 pt-8'>
          <div className='flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0'>
            <div className='text-cream text-sm'>
              © {currentYear} ColdProcessSoaps.com. All rights reserved.
            </div>
            <div className='text-cream text-sm'>
              <span className='text-muted-gray'>
                Educational content only.{' '}
              </span>
              Always follow proper safety procedures when making soap.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
